///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../collections/product-categories.collection.ts"/>
///<reference path="../collections/services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {
    import Variant = Model.Variant;


    export class ProductVariantsCollection extends SmartMoverApiCollection<Variant> implements IApiCollection<Variant> {
        get url() {
            return 'productvariant';
        }

        protected get CollectionModel() {
            return VariantModel;
        }

        constructor(connectedModel: ModelValueType[], items: Variant[] = [], options: ICollectionOptions<Variant> = {}) {
            super(connectedModel, items, options);
            this.sortBy = "SKU";
        }
    }

}